import { ComplexQuestion } from 'src/app/modules/user/modules/questions-framework/components/question-builder/models/question-models/complex-question.model';

export class CompletedQuestion {
  // isCurrent flag should be used to set class current
  // isOnFocus flag is used when the question is focused and should be answered
  // isAnswered is used when the question is answered
  constructor(public question: ComplexQuestion, public isOnFocus: boolean, public isAnswered: boolean, public isCurrent: boolean) { }
}
